import { IconButton } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';
import Table from "../table";
import { DataGrid } from "@mui/x-data-grid"
const VendorTable = ({ rows, handleAddFriend, handleDetailOpen, handleDelete }) => {
    const role_id = localStorage.getItem('role_id')
    const columns = [
        { field: 'index', headerName: 'ลำดับ', width: 100, align: 'center' },
        // role_id === '2' ? {
        //     field: 'vendor_name', headerName: 'หัวจุด', width: 300, align: 'center',
        // } : "",
        role_id === '2' ? {
            field: 'tag_user_id', headerName: 'Sub ID', width: 300, align: 'center',
        } : "",
        role_id === '3' ? {
            field: 'tag_user_id', headerName: 'FarmerID', width: 300, align: 'center',
        } : "",
        { field: 'ownner_name', headerName: 'ชื่อ-นามสกุล', width: 400, align: 'center' },
        { field: 'description', headerName: 'หมายเหตุ', width: 300, align: 'center' },
        { field: 'tel_no', headerName: 'เบอร์โทร', width: 200, align: 'center' },
        { field: 'status', headerName: 'สถานะ', width: 200, align: 'center' },
        {
            field: "delete",
            headerName: "ลบ",
            width: 200,
            align: 'center',
            renderCell: (params) => (
                params.row.status !== 'เพิ่มแล้ว' ? null : (
                    <IconButton color="primary" onClick={() => handleDelete(params.row)}>
                        <DeleteOutlineIcon sx={{ color: '#15322D' }} />
                    </IconButton>
                )
            ),
        },
        {
            field: "detail",
            headerName: "รายละเอียด",
            width: 150,
            align: 'center',
            renderCell: (params) => (
                <IconButton color="primary" onClick={() => handleDetailOpen(params.row.user_id)}>
                    <SearchIcon sx={{ color: '#15322D' }} />
                </IconButton>
            ),
        },
    ]
    return (
        <div style={{ height: 600, width: "100%" }}>
            <Table
                columns={columns}
                rows={rows}
            />
        </div>
    )
}

export default VendorTable